import React from 'react'
import styled from '@xstyled/styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import { SectionTitle, SectionDescription } from '../components/Section'
import { Container } from '../components/Container'
import { Seo } from '../containers/Seo'
import { AboutContainer, AboutText, AboutImage } from '../containers/About'

export const Caption = styled.div`
  margin: 2;
  font-size: 12;
  color: light400;
  text-align: center;
`

export default function AboutPage() {
  const data = useStaticQuery(graphql`
    query {
      photo: file(relativePath: { eq: "family-photo.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      photo1: file(relativePath: { eq: "baloncesto.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      photo2: file(relativePath: { eq: "graduacion.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      photo3: file(relativePath: { eq: "kpmg.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <>
      <Seo title="About León G. Martínez Ostos" />
      <AboutContainer>
        <Container>
          <SectionTitle>Hi I&#39;m León G.!</SectionTitle>
          <SectionDescription>
            I'm a web developer and I love to build amazing things with GatsbyJS
            and NextJS.
          </SectionDescription>
        </Container>
        <AboutImage img={data.photo.childImageSharp} />
        <Caption>Yaslen, Naomi and me.</Caption>
        <AboutText>
          <p>
            Hello, my name is Leon G. Martinez Ostos, I am 33 years old, I am
            Venezuelan and I am currently living in the city of Barranquilla,
            Colombia.
          </p>
          <p>
            I am husband of Yaslen{' '}
            <span role="img" aria-label="emoji de corazon">
              💓
            </span>{' '}
            and father of Naomi{' '}
            <span role="img" aria-label="emoji amoroso">
              😍
            </span>{' '}
            (5 years old).
          </p>
          <p>
            In 2011 I got my technical degree in{' '}
            <strong>computer science</strong>, since then I have accumulated
            more than 7 years of professional experience in different branches
            of computer science such as (Programming, Technical Support, Quality
            Control, Systems Analysis and Networking).
          </p>
          <AboutImage img={data.photo2.childImageSharp} />
          <Caption>Graduation ceremony.</Caption>
          <p>
            Among the companies where I have contributed my knowledge are:{' '}
            <a
              href="https://es.wikipedia.org/wiki/Aserca_Airlines"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aserca Airlines
            </a>
            ,{' '}
            <a
              href="http://siragon.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Síragon de Venezuela
            </a>
            ,{' '}
            <a
              href="https://ve.epaenlinea.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ferreteria EPA
            </a>
            ,{' '}
            <a
              href="https://grupoemi.com/venezuela/"
              target="_blank"
              rel="noopener noreferrer"
            >
              EMI de Venezuela
            </a>
            ,{' '}
            <a
              href="https://home.kpmg/ve/es/home.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              KPMG de Venezuela
            </a>{' '}
            y{' '}
            <a
              href="https://tysglobalsoft.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              GlobalSoft T&S
            </a>
          </p>
          <AboutImage img={data.photo3.childImageSharp} />
          <Caption>A typical day at KPMG Venezuela.</Caption>
          <p>
            I like the idea of always learning new things and keep myself at the
            forefront in the topics of interest, so in early 2020 I decided to
            recover my career as a web developer and learn new technologies. The
            plan was to strengthen my knowledge in HTML5, CSS3 and JavaScript,
            then I took courses in React JS and Frameworks (GatsbyJS and
            NextJS). I also have knowledge in databases (SQL server, MySQL and
            PostgreSQL).
          </p>
          <p>
            As complementary data I can add that I am a cryptocurrency
            <span role="img" aria-label="emoji coin">
              {' '}
              💰
            </span>{' '}
            and decentralized market enthusiast, I also enjoy sports and I used
            to play baseball{' '}
            <span role="img" aria-label="emoji baseball">
              ⚾
            </span>{' '}
            and basketball{' '}
            <span role="img" aria-label="emoji basketball">
              🏀
            </span>{' '}
            with my friends.
          </p>
          <AboutImage img={data.photo1.childImageSharp} />
          <Caption>Playing basketball.</Caption>
          <p>
            Do you want to go deeper about my professional profile?.{' '}
            <strong>Feel free to connect with me</strong>{' '}
            <span role="img" aria-label="finger point to the right">
              👉
            </span>
            <a href="https://www.linkedin.com/in/leonwebdev/" target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
          </p>
        </AboutText>
      </AboutContainer>
    </>
  )
}
